module.exports = require('./dist/app-module/server/lib/GlobalMarkupOptions');
